module.exports = __webpack_public_path__ + "img/business-centre.01f7b5f6.jpg";